import React, { useState } from "react";
import ContactFooterFormCard from "./ContactFooterFormCard";

const API = process.env.REACT_APP_API_URL;

export default function ContactFooterForm({ form }) {
  const [values, setValues] = useState({ name: "", email: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState("");

  const onChange = (event) => {
    const { name, value } = event.target;
    setValues((current) => ({ ...current, [name]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setIsSuccess(false);
    setError("");

    try {
      const res = await fetch(`${API}/contact-form`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });

      if (!res.ok) {
        throw new Error(form.errorMessage);
      }

      setValues({ name: "", email: "", message: "" });
      setIsSuccess(true);
    } catch (err) {
      setError(err.message || form.errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ContactFooterFormCard
      form={form}
      values={values}
      onChange={onChange}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      isSuccess={isSuccess}
      error={error}
    />
  );
}
